import React from "react"
import { create } from "jss"
import {
  ThemeProvider as MuiV4ThemeProvider,
  StylesProvider,
  jssPreset,
} from "@material-ui/core/styles"
import { createMuiTheme } from "@material-ui/core"
import { ThemeProvider, createTheme } from "@mui/material/styles"

import GlobalContextProvider from "./src/context/GlobalContextProvider"
import AuthenticationProvider from "./src/services/authenticationProvider"

import "./src/styles/global.css"
import "./src/styles/stripe.css"

import { createInstance, OptimizelyProvider } from "@optimizely/react-sdk"

const optimizely = createInstance({
  sdkKey: process.env.GATSBY_OPTIMIZELY_SDK_KEY,
})

// Pin MUI v4 JSS styles to the top of <head> so MUI v6 emotion styles
// (injected later) always win by source order on client-side navigation.
const jss = typeof document !== "undefined"
  ? create({
      ...jssPreset(),
      insertionPoint: document.getElementById("jss-insertion-point"),
    })
  : undefined

const v4Theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000000",
      light: "#181818",
      danger: "#F33434",
      active: "#282828",
      partialBorder: "#EEEECC",
    },
    secondary: {
      main: "#F3A634",
    },
  },
  typography: {
    fontFamily: "mundial, sans-serif",
    size: {
      sidebar: "16px",
    },
    color: {
      light: "#FFFFFF",
      dark: "#ADADAD",
      hover: "#474747",
    },
  },
  props: {
    MuiButtonBase: {
      // Disable ripple globally.
      disableRipple: true,
      // The class will be added (as is, ie `focus-visible`)
      // To the ButtonBase root whenever the button gets focus via keyboard.
      focusVisibleClassName: "focus-visible",
    },
  },
  overrides: {
    MuiButtonBase: {
      // And this is how we select it.
      root: {
        "&.focus-visible": {
          outline: "-webkit-focus-ring-color auto 2px !important",
        },
      },
    },
  },
})

const v6Theme = createTheme({
  typography: {
    fontFamily: "mundial, sans-serif",
  },
})

export const wrapRootElement = ({ element }) => {
  const v4Provider = jss ? (
    <StylesProvider jss={jss}>
      <MuiV4ThemeProvider theme={v4Theme}>
        {element}
      </MuiV4ThemeProvider>
    </StylesProvider>
  ) : (
    <MuiV4ThemeProvider theme={v4Theme}>
      {element}
    </MuiV4ThemeProvider>
  )

  return (
    <OptimizelyProvider optimizely={optimizely}>
      <ThemeProvider theme={v6Theme}>
        <GlobalContextProvider>
          <AuthenticationProvider>
            {v4Provider}
          </AuthenticationProvider>
        </GlobalContextProvider>
      </ThemeProvider>
    </OptimizelyProvider>
  )
}
